<template >

 
    <div class="login">
      <user-login></user-login>
    </div>
  

		<div class="info">
      
      <v-card class="mx-auto" max-width="500">
        <v-card-title color="surface-variant" class="title-text">
            相關資訊
        </v-card-title>
        <v-card-text>
          <p>歡迎使用本系統，</p><p>可隨時上網關心子女在校缺課情形</p>
          <p>請輸入貴子女 <span class="highlight">學號</span> 及 <span class="highlight">身分證號</span> 登入本系統。</p>
          <p><br></p>
          <p>使用上若有問題請電洽學校專線<b>06-2533131</b></p>
          <p>系統登入問題：計網中心　 分機<b>2605</b></p>
          <p>缺課獎懲問題：生活輔導組 分機<b>2203</b></p>
        </v-card-text>
       
    </v-card>
    <v-snackbar v-model="snack">{{ msg }}</v-snackbar>
		</div>
	  
    
</template>
 

<script >
  export default {
    name: "login",
    lang: "ts",
    title: "login",
    
  }
  //setPageLayout('login');
  //definePageMeta({
  //  layout: "login",
  //});



 </script>